import store from "../store";

const availables = [2, 3, 4, 21, 15, 18, 19, 22, 23, 24, 25, 26, 27, 28, 29];
const lodopHelper = {

  async print(data) {
    const result = this.getHtml(data);
    // console.log("result", result);
    return result || "无法解析的打印信息";
  },

  getHtml(data) {
    if (!availables.includes(parseInt(data.type))) {
      alert("无法解析的打印信息");
      return;
    }
    const printWidth = parseInt(localStorage.qiantaiPrintSize) || 58;
    
    // 点菜单
    if (data.type == 2) {
      let html = ``;
      if (printWidth == 58) {
        html = `<div style="width: 48mm;">`
      } else {
        html = `<div style="width: 70mm;">`
      }
      html += `
        <div style="padding: 5mm 0mm 8mm 0mm;">
          <div style="font-size: 20px; font-weight: bold; text-align: center; margin-bottom: 10px;">${data.shopName}</div>
          <div style="font-size: 18px; font-weight: bold; text-align: center; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px dashed black;">${data.isReprint == 1 ? '☆点菜单补打☆' : '☆☆点菜单☆☆'}</div>
      ` 
      if (data.meal_type == 1) {
        html += `
            <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.desk_num}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">人数：${data.people}</div>
          `
      } else if (data.meal_type == 2) {
        if (data.order_type_index == 1 || data.order_type_index == 2) {
          html += `
              <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.serial_number}</div>
            `
        } else {
          html += `
              <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.pick_order_num}</div>
            `
        }
      }
      html += `
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">下单人员：${data.admin_name || '无'}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">下单时间：${data.date + ' ' + data.time}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 5px; padding-bottom: 5px; border-bottom: 1px dashed black;">订单单号：${data.orderNum}</div>
        `
      if (data.remark || data.order_remark) {
        html += `
            <div style="font-size: 17px; font-weight: bold; text-align: left; margin-bottom: 4px; padding-bottom: 5px; border-bottom: 1px dashed black;">备注：${data.remark || data.order_remark}</div>
          `
      }
      // if (printWidth == 58) {
        html += `
            <table style="font-size: 12px; margin-bottom: 10px; width: 100%;">
              <tr>
                <th style="text-align: left; width: 19%;">名称</th>
                <th style="text-align: center; width: 27%;">单价</th>
                <th style="text-align: center; width: 27%;">数量</th>
                <th style="text-align: center; width: 27%;">小计</th>
              </tr>
            `
        if (data.printDishList) {
          if (data.printDishList.length > 0) {
            for (let i = 0; i < data.printDishList.length; i++) {
              const element = data.printDishList[i];
              html += `
                  <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element[8] == 3 ? '(套)' : ''}${element[1]}</td></tr>
                  <tr>
                    <td style="text-align: left; width: 19%;"></td>
                    <td style="text-align: center; width: 27%;">${element[4]}</td>
                    <td style="text-align: center; width: 27%;">${element[2].toString()}</td>
                    <td style="text-align: center; width: 27%;">${element[3]}</td>
                  </tr>
                `
              if (element[8] == 3) {
                if (element[9] && element[9] != '') {
                  let setmeal = JSON.parse(element[9]);
                  for (let j = 0; j < setmeal.length; j++) {
                    const setmeal_food = setmeal[j];
                    html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}</td></tr>
                    `
                  }
                }
              } else {
                if (element[5] && element[5] != '' && element[7] != 1) {
                  html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
                    `
                }
              }
            }
          }
        }
        html += `
            </table>
          `
      // } else {
      //   html += `
      //       <table style="font-size: 12px; margin-bottom: 10px; width: 100%;">
      //         <tr>
      //           <th style="text-align: left; width: 19%;">名称</th>
      //           <th style="text-align: center; width: 27%;">单价</th>
      //           <th style="text-align: center; width: 27%;">数量</th>
      //           <th style="text-align: center; width: 27%;">小计</th>
      //         </tr>
      //     `
      //   if (data.printDishList) {
      //     if (data.printDishList.length > 0) {
      //       for (let i = 0; i < data.printDishList.length; i++) {
      //         const element = data.printDishList[i];
      //         html += `
      //             <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element[8] == 3 ? '(套)' : ''}${element[1]}</td></tr>
      //             <tr style="font-size: 12px; margin-bottom: 8px;">
      //               <td style="text-align: left; width: 19%;"></td>
      //               <td style="text-align: center; width: 27%;">${element[4]}</td>
      //               <td style="text-align: center; width: 27%;">${element[2].toString()}</td>
      //               <td style="text-align: center; width: 27%;">${element[3]}</td>
      //             </tr>
      //           `
      //         if (element[8] == 3) {
      //           if (element[9] && element[9] != '') {
      //             let setmeal = JSON.parse(element[9]);
      //             for (let j = 0; j < setmeal.length; j++) {
      //               const setmeal_food = setmeal[j];
      //               html += `
      //                 <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}</td></tr>
      //               `
      //             }
      //           }  
      //         } else {
      //           if (element[5] && element[5] != '' && element[7] != 1) {
      //             html += `
      //                 <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
      //               `
      //           }
      //         }
      //       }
      //     }
      //   }
      //   html += `
      //       </table>
      //     `
      // }

      if (data.addprintDishList) {
        if (data.addprintDishList.length > 0) {
          html += `
              <div style="font-size: 12px; text-align: center; margin-bottom: 10px; margin-top: 10px;">***加菜***</div>
            `
          html += `
              <table style="width: 100%;">
            `
          // if (printWidth == 58) {
            for (let i = 0; i < data.addprintDishList.length; i++) {
              const element = data.addprintDishList[i];
              html += `
                  <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element[8] == 3 ? '(套)' : ''}${element[1]}</td></tr>
                  <tr style="font-size: 12px; margin-bottom: 8px;">
                    <td style="text-align: left; width: 19%;"></td>
                    <td style="text-align: center; width: 27%;">${element[4]}</td>
                    <td style="text-align: center; width: 27%;">${element[2].toString()}</td>
                    <td style="text-align: center; width: 27%;">${element[3]}</td>
                  </tr>
                `
              if (element[8] == 3) {
                if (element[9] && element[9] != '') {
                  let setmeal = JSON.parse(element[9]);
                  for (let j = 0; j < setmeal.length; j++) {
                    const setmeal_food = setmeal[j];
                    html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}</td></tr>
                    `
                  }
                }
              } else {
                if (element[5] && element[5] != '' && element[7] != 1) {
                  html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
                    `
                }
              }
            }
          // } else {
          //   for (let i = 0; i < data.addprintDishList.length; i++) {
          //     const element = data.addprintDishList[i];
          //     html += `
          //         <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element[8] == 3 ? '(套)' : ''}${element[1]}</td></tr>
          //         <tr style="font-size: 12px; margin-bottom: 8px;">
          //           <td style="text-align: left; width: 19%;"></td>
          //           <td style="text-align: center; width: 27%;">${element[4]}</td>
          //           <td style="text-align: center; width: 27%;">${element[2].toString()}</td>
          //           <td style="text-align: center; width: 27%;">${element[3]}</td>
          //         </tr>
          //       `
          //     if (element[8] == 3) {
          //       if (element[9] && element[9] != '') {
          //         let setmeal = JSON.parse(element[9]);
          //         for (let j = 0; j < setmeal.length; j++) {
          //           const setmeal_food = setmeal[j];
          //           html += `
          //             <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}</td></tr>
          //           `
          //         }
          //       }
          //     } else {
          //       if (element[5] && element[5] != '' && element[7] != 1) {
          //         html += `
          //             <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
          //           `
          //       }
          //     }
          //   }
          // }
          html += `
              </table>
            `
        }
      }
      let hj = '0.00';
      if (data.one_dis) {
        if (data.one_dis === 'one_dis') {
          hj = data.allOriginalPrice.toString();
        } else {
          hj = data.one_dis.toString();
        }
      } else {
        hj = '0.00';
      }
      html += `
          <div style="font-size: 12px; font-weight: bold; padding: 5px 0; margin-bottom: 10px; border-top: 1px dashed black; border-bottom: 1px dashed black;">订单合计：${hj}</div>

          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">门店地址：${data.address}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">联系电话：${data.phone}</div>
      `;
      html += `<div style="font-size: 13px; padding: 5px 0; margin-bottom: 10px; border-top: 1px dashed black; font-weight: 600; text-align: center;">店掌宝祝您用餐愉快！</div>`
      html += `</div>`
      html += `</div>`
      return html;
    }

    // 结账单
    if (data.type == 4) {
      let html = ``;
      if (printWidth == 58) {
        html = `<div style="width: 48mm;">`
      } else {
        html = `<div style="width: 70mm;">`
      }
      html += `
          <div style="padding: 5mm 0mm 8mm 0mm;">
            <div style="font-size: 20px; text-align: center; margin-bottom: 10px;">${data.shopName}</div>
        ` 
      let xiaop = '';
      if (data.meal_type == 1 || (data.meal_type == 2 && data.order_type_index == 2)) {
        if (data.isReprint == 1) {
          xiaop += '☆结账单补打☆'
        } else {
          xiaop = '☆☆结账单☆☆'
        }
      } else {
        if (data.order_type_index == 3) {
          xiaop = '☆☆自取单☆☆';
        } else if (data.order_type_index == 4) {
          xiaop = '☆☆外卖单☆☆';
        }
      }
      html += `
          <div style="font-size: 18px; font-weight: bold; text-align: center; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px dashed black;">${xiaop}</div>  
        `
      let pack_or_dineIn_text = ``;
      if (data.pack_or_dineIn == 1) { // 打包
        pack_or_dineIn_text = '(打包)'
      } else if (data.pack_or_dineIn == 2) { // 堂食
        pack_or_dineIn_text = '(堂食)'
      }
      if (data.meal_type == 1) {
        html += `
            <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.num}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">人数：${data.people}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">收银人员：${data.admin_name || '无'}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">收银时间：${data.cashier_time || ''}</div>
          `
      } else if (data.meal_type == 2) {
        if (data.order_type_index == 1 || data.order_type_index == 2) {
          html += `
              <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.serial_number}${pack_or_dineIn_text}</div>
              <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">收银人员：${data.admin_name || '无'}</div>
              <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">收银时间：${data.cashier_time || ''}</div>
            `
        } else {
          html += `
              <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.pick_order_num}${pack_or_dineIn_text}</div>
              <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">下单时间：${data.down_time || ''}</div>
            `
        }
      }
      html += `
          <div style="font-size: 12px; text-align: left; margin-bottom: 5px; padding-bottom: 5px; border-bottom: 1px dashed black;">订单单号：${data.orderNum}</div>
        `
      if (data.c_name && data.c_phone && data.send_address) {
        html += `
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">姓名：${data.c_name}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">电话：${data.c_phone}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px; padding-bottom: 5px; border-bottom: 1px dashed black;">地址：${data.send_address}</div>
          `
      }
      if (data.remark && data.remark != '') {
        html += `
            <div style="font-size: 17px; font-weight: bold; text-align: left; margin-bottom: 4px; padding-bottom: 5px; border-bottom: 1px dashed black;">备注：${data.remark}</div>
          `
      }
      // if (printWidth == 58) {
        html += `
            <table style="font-size: 12px; margin-bottom: 10px; width: 100%;">
              <tr>
                <th style="text-align: left; width: 19%;">名称</th>
                <th style="text-align: center; width: 27%;">单价</th>
                <th style="text-align: center; width: 27%;">数量</th>
                <th style="text-align: center; width: 27%;">小计</th>
              </tr>
            `
        if (data.printDishList) {
          if (data.printDishList.length > 0) {
            for (let i = 0; i < data.printDishList.length; i++) {
              const element = data.printDishList[i];
              html += `
                  <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element[8] == 3 ? '(套)' : ''}${element[1]}</td></tr>
                  <tr>
                    <td style="text-align: left; width: 19%;"></td>
                    <td style="text-align: center; width: 27%;">${element[4]}</td>
                    <td style="text-align: center; width: 27%;">${element[2].toString()}</td>
                    <td style="text-align: center; width: 27%;">${element[3]}</td>
                  </tr>
                `
              if (element[8] == 3) {
                if (element[9] && element[9] != '') {
                  let setmeal = JSON.parse(element[9]);
                  for (let j = 0; j < setmeal.length; j++) {
                    const setmeal_food = setmeal[j];
                    html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}</td></tr>
                    `
                  }
                }
              } else {
                if (element[5] && element[5] != '' && element[7] != 1) {
                  html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
                    `
                }
              }
            }
          }
        }
        html += `
            </table>
          `
      // } else {
      //   html += `
      //       <table style="font-size: 12px; margin-bottom: 10px; width: 100%;">
      //         <tr>
      //           <th style="text-align: left; width: 19%;">名称</th>
      //           <th style="text-align: center; width: 27%;">单价</th>
      //           <th style="text-align: center; width: 27%;">数量</th>
      //           <th style="text-align: center; width: 27%;">小计</th>
      //         </tr>
      //     `
      //   if (data.printDishList) {
      //     if (data.printDishList.length > 0) {
      //       for (let i = 0; i < data.printDishList.length; i++) {
      //         const element = data.printDishList[i];
      //         html += `
      //             <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element[8] == 3 ? '(套)' : ''}${element[1]}</td></tr>
      //             <tr style="font-size: 12px; margin-bottom: 8px;">
      //               <td style="text-align: left; width: 19%;"></td>
      //               <td style="text-align: center; width: 27%;">${element[4]}</td>
      //               <td style="text-align: center; width: 27%;">${element[2].toString()}</td>
      //               <td style="text-align: center; width: 27%;">${element[3]}</td>
      //             </tr>
      //           `
      //         if (element[8] == 3) {
      //           if (element[9] && element[9] != '') {
      //             let setmeal = JSON.parse(element[9]);
      //             for (let j = 0; j < setmeal.length; j++) {
      //               const setmeal_food = setmeal[j];
      //               html += `
      //                 <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}</td></tr>
      //               `
      //             }
      //           }
      //         } else {
      //           if (element[5] && element[5] != '' && element[7] != 1) {
      //             html += `
      //                 <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
      //               `
      //           }
      //         }
      //       }
      //     }
      //   }
      //   html += `
      //       </table>
      //     `
      // }

      if (data.addprintDishList) {
        if (data.addprintDishList.length > 0) {
          html += `
              <div style="font-size: 12px; text-align: center; margin-bottom: 10px; margin-top: 10px;">***加菜***</div>
            `
          html += `
              <table style="width: 100%; font-size: 12px; width: 100%;">
            `
          // if (printWidth == 58) {
            for (let i = 0; i < data.addprintDishList.length; i++) {
              const element = data.addprintDishList[i];
              html += `
                  <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element[8] == 3 ? '(套)' : ''}${element[1]}</td></tr>
                  <tr style="font-size: 12px; margin-bottom: 8px;">
                    <td style="text-align: left; width: 19%;"></td>
                    <td style="text-align: center; width: 27%;">${element[4]}</td>
                    <td style="text-align: center; width: 27%;">${element[2].toString()}</td>
                    <td style="text-align: center; width: 27%;">${element[3]}</td>
                  </tr>
                `
              if (element[8] == 3) {
                if (element[9] && element[9] != '') {
                  let setmeal = JSON.parse(element[9]);
                  for (let j = 0; j < setmeal.length; j++) {
                    const setmeal_food = setmeal[j];
                    html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}</td></tr>
                    `
                  }
                }
              } else {
                if (element[5] && element[5] != '' && element[7] != 1) {
                  html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
                    `
                }
              }
            }
          // } else {
          //   for (let i = 0; i < data.addprintDishList.length; i++) {
          //     const element = data.addprintDishList[i];
          //     html += `
          //         <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element[8] == 3 ? '(套)' : ''}${element[1]}</td></tr>
          //         <tr style="font-size: 12px; margin-bottom: 8px;">
          //           <td style="text-align: left; width: 19%;"></td>
          //           <td style="text-align: center; width: 27%;">${element[4]}</td>
          //           <td style="text-align: center; width: 27%;">${element[2].toString()}</td>
          //           <td style="text-align: center; width: 27%;">${element[3]}</td>
          //         </tr>
          //       `
          //     if (element[8] == 3) {
          //       if (element[9] && element[9] != '') {
          //         let setmeal = JSON.parse(element[9]);
          //         for (let j = 0; j < setmeal.length; j++) {
          //           const setmeal_food = setmeal[j];
          //           html += `
          //             <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}</td></tr>
          //           `
          //         }
          //       }
          //     } else {
          //       if (element[5] && element[5] != '' && element[7] != 1) {
          //         html += `
          //             <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
          //           `
          //       }
          //     }
          //   }
          // }
          html += `
              </table>
            `
        }
      }
      html += `
          <div style="height: 1px; padding-top: 5px; border-top: 1px dashed black;"></div>
          <div style="font-size: 12px; margin-bottom: 4px;">订单合计：${data.allOriginalPrice}</div>
        `
      if (data.order_type_index == 4 && data.deliver_fee && parseFloat(data.deliver_fee) > 0) {
        html += `
            <div style="font-size: 12px; margin-bottom: 4px;">配送费：${data.deliver_fee}</div>
          `
      }
      if (parseFloat(data.discount_price) > 0) {
        html += `
            <div style="font-size: 12px; margin-bottom: 4px;">[会员优惠:${data.member_level_rate >= 100 ? '' : parseFloat(data.member_level_rate / 10).toFixed(2) + '折'}]：-${data.discount_price}</div>
          `
      }
      if (parseFloat(data.dis_price) > 0 && data.discount_rate && data.discount_rate < 100) {
        html += `
            <div style="font-size: 12px; margin-bottom: 4px;">[整单打折:${data.discount_rate >= 100 ? '' : parseFloat(data.discount_rate / 10).toFixed(2) + '折'}]：-${data.dis_price}</div>
          `
      }
      if (parseFloat(data.wipe_price) > 0) {
        html += `
            <div style="font-size: 12px; margin-bottom: 4px;">[抹零]：-${data.wipe_price}</div>
          `
      }

      html += `
          <div style="font-size: 12px; margin-bottom: 4px; padding-top: 5px; border-top: 1px dashed black;">应收：${data.payPrice}</div>
        `
      if (parseFloat(data.return_money) > 0) {
        html += `
            <div style="font-size: 12px; margin-bottom: 4px;">退款：-${data.return_money}</div>
          `
      }
      html += `
          <div style="font-size: 14px; margin-bottom: 4px; font-weight: bold;">实收${data.pay_mode_text ? '(' + data.pay_mode_text + ')' : ''}:${data.allFactPrice}</div>
        `
      if ((data.order_type_index == 1 || data.order_type_index == 2) && data.pay_method == 3) {
        html += `
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px; padding-top: 5px; border-top: 1px dashed black;">会员姓名：${data.member_name || ''}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">会员电话：${data.member_phone && data.member_phone != '' ? data.member_phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2') : ''}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">余额：${data.member_balance || ''}</div>
          `;
      }
      html += `
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px; padding-top: 5px; border-top: 1px dashed black;">门店地址：${data.address}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">联系电话：${data.phone}</div>
      `;
      html += `<div style="font-size: 13px; padding: 5px 0; margin-bottom: 10px; border-top: 1px dashed black; font-weight: 600; text-align: center;">店掌宝祝您用餐愉快！</div>`
      html += `</div>`
      html += `</div>`
      return html;
    }

    // 前台做菜单
    if (data.type == 19) {
      let html = ``;
      if (printWidth == 58) {
        html = `<div style="width: 48mm;">`
      } else {
        html = `<div style="width: 70mm;">`
      }
      html += `
        <div style="padding: 5mm 0mm 8mm 0mm;">
          <div style="font-size: 20px; text-align: center; margin-bottom: 10px;">${data.shopName}</div>
          <div style="font-size: 18px; text-align: center; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px dashed black;">☆☆做菜单☆☆</div>
      ` 
      let pack_or_dineIn_text = ``;
      if (data.pack_or_dineIn == 1) { // 打包
        pack_or_dineIn_text = '(打包)'
      } else if (data.pack_or_dineIn == 2) { // 堂食
        pack_or_dineIn_text = '(堂食)'
      }
      if (data.meal_type == 1) {
        html += `
            <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.num || data.desk_num}</div>
          `
      } else if (data.meal_type == 2) {
        if (data.order_type_index == 1 || data.order_type_index == 2) {
          html += `
              <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.serial_number}${pack_or_dineIn_text}</div>
            `
        } else {
          html += `
              <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.pick_order_num}${pack_or_dineIn_text}</div>
            `
        }
      }
      html += `
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">下单时间：${data.create_time}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 5px; padding-bottom: 5px; border-bottom: 1px dashed black;">订单单号：${data.orderNum}</div>
        `
      if (data.remark || data.order_remark) {
        html += `
            <div style="font-size: 17px; font-weight: bold; text-align: left; margin-bottom: 4px; padding-bottom: 5px; border-bottom: 1px dashed black;">备注：${data.remark || data.order_remark}</div>
          `
      }
      html += `
          <table style="font-size: 12px;  margin-bottom: 10px; width: 100%;">
        `
      if (data.foodsList) {
        if (data.foodsList.length > 0) {
          for (let i = 0; i < data.foodsList.length; i++) {
            const element = data.foodsList[i];
            html += `
                <tr style="font-size: 15px; margin-bottom: 8px; font-weight: bold;">
                  <td style="text-align: left; width: 60%;">${i + 1}.${element.type == 3 ? '(套)' : ''}${element.food_name}</td>
                  <td style="text-align: center; width: 40%;">${element.food_num.toString()}${element.type == 1 || element.type == 3 ? (element.unit_name || '份') : ''}</td>
                </tr>
              `
            if (element.type == 3) {
              let spec_json = {};
              if (typeof element.spec_json == 'string') {
                spec_json = JSON.parse(element.spec_json);
              } else if (typeof element.spec_json == 'object') {
                spec_json = element.spec_json || {};
              }
              const info = spec_json.setmeal_list || [];
              for (let m = 0; m < info.length; m++) {
                const mealfood = info[m];
                html += `
                    <tr style="font-size: 15px; margin-bottom: 8px; font-weight: bold;">
                      <td style="text-align: left; width: 60%;">${mealfood.name}${mealfood.attr != '' ? '(' + mealfood.attr + ')' : ''}</td>
                      <td style="text-align: center; width: 40%;">×${mealfood.num}</td>
                    </tr>
                  `
              }
            } else {
              if (element.spec_attr_name && element.spec_attr_name != '' && element.food_spec_fake != 1) {
                html += `
                    <tr style="font-weight: bold;"><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element.spec_attr_name}】</td></tr>
                  `
              }
            }
          }
        }
      }
      html += `
          </table>
        `
      html += `</div>`
      html += `</div>`
      return html;
    }

    // 前台退菜單
    if (data.type == 27) {
      let html = ``;
      if (printWidth == 58) {
        html = `<div style="width: 48mm;">`
      } else {
        html = `<div style="width: 70mm;">`
      }
      html += `
        <div style="padding: 5mm 0mm 8mm 0mm;">
          <div style="font-size: 20px; text-align: center; margin-bottom: 10px;">${data.shopName}</div>
          <div style="font-size: 18px; text-align: center; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px dashed black;">☆☆退菜单☆☆</div>
      ` 
      html += `
          <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">桌位号：${data.desk_num}</div>
        `
      html += `
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">退菜时间：${data.return_time}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 5px; padding-bottom: 5px; border-bottom: 1px dashed black;">订单单号：${data.orderNum}</div>
        `
      // if (printWidth == 58) {
        html += `
            <table style="font-size: 12px; margin-bottom: 10px; width: 100%;">
              <tr>
                <th style="text-align: left; width: 19%;">名称</th>
                <th style="text-align: center; width: 27%;">单价</th>
                <th style="text-align: center; width: 27%;">数量</th>
                <th style="text-align: center; width: 27%;">小计</th>
              </tr>
          `
        if (data.returnFoodsList) {
          data.returnFoodsList = JSON.parse(data.returnFoodsList)
          if (data.returnFoodsList.length > 0) {
            for (let i = 0; i < data.returnFoodsList.length; i++) {
              const element = data.returnFoodsList[i];
              html += `
                  <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element.type == 3 ? '(套)' : ''}${element.food_name}</td></tr>
                  <tr>
                    <td style="text-align: left; width: 19%;"></td>
                    <td style="text-align: center; width: 27%;">${element.price}</td>
                    <td style="text-align: center; width: 27%;">-${element.return_num.toString()}</td>
                    <td style="text-align: center; width: 27%;">-${element.totalPrice}</td>
                  </tr>
                `
              if (element.type == 3) {
                for (let m = 0; m < element.c_setmeal_list.length; m++) {
                  const mealfood = element.c_setmeal_list[m];
                  html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">  ${mealfood.name}${mealfood.attr != '' ? '(' + mealfood.attr + ')' : ''}×${mealfood.num}</td></tr>
                    `
                }
              } else {
                if (element.spec_attr_name && element.spec_attr_name != '' && element.food_spec_fake != 1) {
                  html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element.spec_attr_name}】</td></tr>
                    `
                }
              }
            }
          }
        }
        html += `
            </table>
          `
      // } else {
      //   html += `
      //       <table style="font-size: 12px; margin-bottom: 10px; width: 100%;">
      //         <tr>
      //           <th style="text-align: left; width: 19%;">名称</th>
      //           <th style="text-align: center; width: 27%;">单价</th>
      //           <th style="text-align: center; width: 27%;">数量</th>
      //           <th style="text-align: center; width: 27%;">小计</th>
      //         </tr>
      //     `
      //   if (data.returnFoodsList) {
      //     data.returnFoodsList = JSON.parse(data.returnFoodsList)
      //     if (data.returnFoodsList.length > 0) {
      //       for (let i = 0; i < data.returnFoodsList.length; i++) {
      //         const element = data.returnFoodsList[i];
      //         html += `
      //             <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element.food_name}</td></tr>
      //             <tr>
      //               <td style="text-align: left; width: 19%;"></td>
      //               <td style="text-align: center; width: 27%;">${element.price}</td>
      //               <td style="text-align: center; width: 27%;">-${element.return_num.toString()}</td>
      //               <td style="text-align: center; width: 27%;">-${element.totalPrice}</td>
      //             </tr>
      //           `
      //         if (element.type == 3) {
      //           for (let m = 0; m < element.c_setmeal_list.length; m++) {
      //             const mealfood = element.c_setmeal_list[m];
      //             html += `
      //                 <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">  ${mealfood.name}${mealfood.attr != '' ? '(' + mealfood.attr + ')' : ''}×${mealfood.num}</td></tr>
      //               `
      //           }
      //         } else {
      //           if (element.spec_attr_name && element.spec_attr_name != '' && element.food_spec_fake != 1) {
      //             html += `
      //                 <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element.spec_attr_name}】</td></tr>
      //               `
      //           }
      //         }
      //       }
      //     }
      //   }
      //   html += `
      //       </table>
      //     `
      // }
      html += `<div style="font-size: 12px; font-weight: bold; padding: 5px 0; border-top: 1px dashed black;">订单合计：-${data.returnTotalPrice || '0'}</div>`
      html += `</div>`
      html += `</div>`
      return html;
    }

    // 日报
    if (data.type == 21) {
      let html = ``;
      if (printWidth == 58) {
        html = `<div style="width: 48mm;">`
      } else {
        html = `<div style="width: 70mm;">`
      }
      html += `
        <div style="padding: 5mm 0mm 8mm 0mm;">
          <div style="font-size: 20px; text-align: center; margin-bottom: 10px;">${data.shop_name}</div>
          <div style="font-size: 18px; text-align: center; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px dashed black;">☆☆日报☆☆</div>
      `
      html += `
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">操作员：${data.shop_admin_name || '无'}</div>
          <div style="font-size: 12px; text-align: left;">开始时间：${data.start_time}</div>
          <div style="font-size: 12px; text-align: left;">结束时间：${data.end_time}</div>
        `
      try {
        data.daily = JSON.parse(data.daily)
      } catch (err) {
        data.daily = {}
        html += `<div style="font-size: 12px; text-align: left;">${err.message}</div>`
      }
      for (const key in data.daily) {
        if (Object.hasOwnProperty.call(data.daily, key)) {
          const element = data.daily[key];
          html += `<div style="width: 100%; height: 1px; margin: 8px 0; border-bottom: 1px dashed black;"></div>`
          for (let i = 0; i < element.length; i++) {
            const ele = element[i];
            if (i == 0) {
              html += `
                  <div style="font-size: 18px; font-weight: bold; margin-bottom: 5px;">${ele.label || ''}${ele.middleVal || ''}${ele.value || ''}</div>
                `
            } else {
              html += `
                  <div style="font-size: 12px; margin-bottom: 5px;">${ele.label || ''}${ele.middleVal || ''}${ele.value || ''}</div>
                `
            }
          }
        }
      }
      html += `<div style="font-size: 13px; padding: 5px 0; margin-bottom: 10px; margin-top: 5px; border-top: 1px dashed black; font-weight: 600; text-align: center;">店掌宝祝您生意兴隆！</div>`
      html += `</div>`
      html += `</div>`
      return html;
    }

    // 加菜单
    if (data.type == 22) {
      let html = ``;
      if (printWidth == 58) {
        html = `<div style="width: 48mm;">`
      } else {
        html = `<div style="width: 70mm;">`
      }
      html += `
        <div style="padding: 5mm 0mm 8mm 0mm;">
          <div style="font-size: 20px; font-weight: bold; text-align: center; margin-bottom: 10px;">${data.shopName}</div>
          <div style="font-size: 18px; font-weight: bold; text-align: center; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px dashed black;">☆☆加菜单☆☆</div>
      ` 
      let pack_or_dineIn_text = ``;
      if (data.pack_or_dineIn == 1) { // 打包
        pack_or_dineIn_text = '(打包)'
      } else if (data.pack_or_dineIn == 2) { // 堂食
        pack_or_dineIn_text = '(堂食)'
      }
      if (data.meal_type == 1) {
        html += `
            <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.desk_num}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">人数：${data.people}</div>
          `
      } else if (data.meal_type == 2) {
        if (data.order_type_index == 1 || data.order_type_index == 2) {
          html += `
              <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.serial_number}${pack_or_dineIn_text}</div>
            `
        } else {
          html += `
              <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.pick_order_num}${pack_or_dineIn_text}</div>
            `
        }
      }
      html += `
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">加菜时间：${data.create_time || ''}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 5px; padding-bottom: 5px; border-bottom: 1px dashed black;">订单单号：${data.orderNum}</div>
        `
      if (data.remark || data.order_remark) {
        html += `
            <div style="font-size: 17px; font-weight: bold; text-align: left; margin-bottom: 4px; padding-bottom: 5px; border-bottom: 1px dashed black;">备注：${data.remark || data.order_remark}</div>
          `
      }
      if (printWidth == 58) {
        html += `
            <table style="font-size: 12px; margin-bottom: 10px; width: 100%;">
              <tr>
                <th style="text-align: left; width: 19%;">名称</th>
                <th style="text-align: center; width: 27%;">单价</th>
                <th style="text-align: center; width: 27%;">数量</th>
                <th style="text-align: center; width: 27%;">小计</th>
              </tr>
            `
        if (data.addprintDishList) {
          if (data.addprintDishList.length > 0) {
            for (let i = 0; i < data.addprintDishList.length; i++) {
              const element = data.addprintDishList[i];
              html += `
                  <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element[8] == 3 ? '(套)' : ''}${element[1]}</td></tr>
                  <tr>
                    <td style="text-align: left; width: 19%;"></td>
                    <td style="text-align: center; width: 27%;">${element[4]}</td>
                    <td style="text-align: center; width: 27%;">${element[2].toString()}</td>
                    <td style="text-align: center; width: 27%;">${element[3]}</td>
                  </tr>
                `
              if (element[8] == 3) {
                if (element[9] && element[9] != '') {
                  let setmeal = JSON.parse(element[9]);
                  for (let j = 0; j < setmeal.length; j++) {
                    const setmeal_food = setmeal[j];
                    html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}</td></tr>
                    `
                  }
                }
              } else {
                if (element[5] && element[5] != '' && element[7] != 1) {
                  html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
                    `
                }
              }
            }
          }
        }
        html += `
            </table>
          `
      } else {
        html += `
            <table style="font-size: 12px; margin-bottom: 10px; width: 100%;">
              <tr>
                <th style="text-align: left; width: 19%;">名称</th>
                <th style="text-align: center; width: 27%;">单价</th>
                <th style="text-align: center; width: 27%;">数量</th>
                <th style="text-align: center; width: 27%;">小计</th>
              </tr>
          `
        if (data.addprintDishList) {
          if (data.addprintDishList.length > 0) {
            for (let i = 0; i < data.addprintDishList.length; i++) {
              const element = data.addprintDishList[i];
              html += `
                  <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element[8] == 3 ? '(套)' : ''}${element[1]}</td></tr>
                  <tr style="font-size: 12px; margin-bottom: 8px;">
                    <td style="text-align: left; width: 19%;"></td>
                    <td style="text-align: center; width: 27%;">${element[4]}</td>
                    <td style="text-align: center; width: 27%;">${element[2].toString()}</td>
                    <td style="text-align: center; width: 27%;">${element[3]}</td>
                  </tr>
                `
              if (element[8] == 3) {
                if (element[9] && element[9] != '') {
                  let setmeal = JSON.parse(element[9]);
                  for (let j = 0; j < setmeal.length; j++) {
                    const setmeal_food = setmeal[j];
                    html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">  ${setmeal_food.name}${setmeal_food.attr != '' ? '(' + setmeal_food.attr + ')' : ''}×${setmeal_food.num}</td></tr>
                    `
                  }
                }
              } else {
                if (element[5] && element[5] != '' && element[7] != 1) {
                  html += `
                      <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
                    `
                }
              }
            }
          }
        }
        html += `
            </table>
          `
      }
      let hj = '0.00';
      if (data.one_dis) {
        if (data.one_dis === 'one_dis') {
          hj = data.allOriginalPrice.toString();
        } else {
          hj = data.one_dis.toString();
        }
      } else {
        hj = '0.00';
      }
      html += `
          <div style="font-size: 12px; padding: 5px 0; margin-bottom: 10px; border-top: 1px dashed black; border-bottom: 1px dashed black;">订单合计：${hj}</div>

          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">门店地址：${data.address}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">联系电话：${data.phone}</div>
      `;
      html += `<div style="font-size: 13px; padding: 5px 0; margin-bottom: 10px; border-top: 1px dashed black; font-weight: 600; text-align: center;">店掌宝祝您用餐愉快！</div>`
      html += `</div>`
      html += `</div>`
      return html;
    }

    // 客单
    if (data.type == 23) {
      let html = ``;
      if (printWidth == 58) {
        html = `<div style="width: 48mm;">`
      } else {
        html = `<div style="width: 70mm;">`
      }
      html += `
          <div style="padding: 5mm 0mm 8mm 0mm;">
            <div style="font-size: 20px; text-align: center; margin-bottom: 10px;">${data.shopName}</div>
        ` 
      let xiaop = '';
      if (data.meal_type == 1 || (data.meal_type == 2 && data.order_type_index == 2)) {
        if (data.isReprint == 1) {
          xiaop += '☆客单补打☆'
        } else {
          xiaop = '☆☆客单☆☆'
        }
      } else {
        if (data.order_type_index == 3) {
          xiaop = '☆☆自取单☆☆';
        } else if (data.order_type_index == 4) {
          xiaop = '☆☆外卖单☆☆';
        }
      }
      html += `
          <div style="font-size: 18px; font-weight: bold; text-align: center; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px dashed black;">${xiaop}</div>  
        `
      let pack_or_dineIn_text = ``;
      if (data.pack_or_dineIn == 1) { // 打包
        pack_or_dineIn_text = '(打包)'
      } else if (data.pack_or_dineIn == 2) { // 堂食
        pack_or_dineIn_text = '(堂食)'
      }
      if (data.meal_type == 1) {
        html += `
            <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.num}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">人数：${data.people}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">收银人员：${data.admin_name || '无'}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">收银时间：${data.cashier_time || ''}</div>
          `
      } else if (data.meal_type == 2) {
        if (data.order_type_index == 1 || data.order_type_index == 2) {
          html += `
              <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.serial_number}${pack_or_dineIn_text}</div>
              <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">收银人员：${data.admin_name || '无'}</div>
              <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">收银时间：${data.cashier_time || ''}</div>
            `
        } else {
          html += `
              <div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">${data.order_type}:${data.pick_order_num}${pack_or_dineIn_text}</div>
              <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">下单时间：${data.down_time || ''}</div>
            `
        }
      }
      html += `
          <div style="font-size: 12px; text-align: left; margin-bottom: 5px; padding-bottom: 5px; border-bottom: 1px dashed black;">订单单号：${data.orderNum}</div>
        `
      if (data.c_name && data.c_phone && data.send_address) {
        html += `
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">姓名：${data.c_name}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">电话：${data.c_phone}</div>
            <div style="font-size: 12px; text-align: left; margin-bottom: 4px; padding-bottom: 5px; border-bottom: 1px dashed black;">地址：${data.send_address}</div>
          `
      }
      if (data.remark && data.remark != '') {
        html += `
            <div style="font-size: 17px; font-weight: bold; text-align: left; margin-bottom: 4px; padding-bottom: 5px; border-bottom: 1px dashed black;">备注：${data.remark}</div>
          `
      }
      if (printWidth == 58) {
        html += `
            <table style="font-size: 12px; margin-bottom: 10px; width: 100%;">
              <tr>
                <th style="text-align: left; width: 19%;">名称</th>
                <th style="text-align: center; width: 27%;">单价</th>
                <th style="text-align: center; width: 27%;">数量</th>
                <th style="text-align: center; width: 27%;">小计</th>
              </tr>
            `
        if (data.printDishList) {
          if (data.printDishList.length > 0) {
            for (let i = 0; i < data.printDishList.length; i++) {
              const element = data.printDishList[i];
              html += `
                  <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element[1]}</td></tr>
                  <tr>
                    <td style="text-align: left; width: 19%;"></td>
                    <td style="text-align: center; width: 27%;">${element[4]}</td>
                    <td style="text-align: center; width: 27%;">${element[2].toString()}</td>
                    <td style="text-align: center; width: 27%;">${element[3]}</td>
                  </tr>
                `
              if (element[5] && element[5] != '' && element[7] != 1) {
                html += `
                    <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
                  `
              }
            }
          }
        }
        html += `
            </table>
          `
      } else {
        html += `
            <table style="font-size: 12px; margin-bottom: 10px; width: 100%;">
              <tr>
                <th style="text-align: left; width: 25%;">名称</th>
                <th style="text-align: center; width: 25%;">单价</th>
                <th style="text-align: center; width: 25%;">数量</th>
                <th style="text-align: center; width: 25%;">小计</th>
              </tr>
          `
        if (data.printDishList) {
          if (data.printDishList.length > 0) {
            for (let i = 0; i < data.printDishList.length; i++) {
              const element = data.printDishList[i];
              html += `
                  <tr style="font-size: 12px; margin-bottom: 8px;">
                    <td style="text-align: left; width: 25%;">${i + 1}.${element[1]}</td>
                    <td style="text-align: center; width: 25%;">${element[4]}</td>
                    <td style="text-align: center; width: 25%;">${element[2].toString()}</td>
                    <td style="text-align: center; width: 25%;">${element[3]}</td>
                  </tr>
                `
              if (element[5] && element[5] != '' && element[7] != 1) {
                html += `
                    <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
                  `
              }
            }
          }
        }
        html += `
            </table>
          `
      }

      if (data.addprintDishList) {
        if (data.addprintDishList.length > 0) {
          html += `
              <div style="font-size: 12px; text-align: center; margin-bottom: 10px; margin-top: 10px;">***加菜***</div>
            `
          html += `
              <table style="width: 100%; font-size: 12px; width: 100%;">
            `
          if (printWidth == 58) {
            for (let i = 0; i < data.addprintDishList.length; i++) {
              const element = data.addprintDishList[i];
              html += `
                  <tr><td colspan="4" style="font-size: 12px;">${i + 1}.${element[1]}</td></tr>
                  <tr style="font-size: 12px; margin-bottom: 8px;">
                    <td style="text-align: left; width: 19%;"></td>
                    <td style="text-align: center; width: 27%;">${element[4]}</td>
                    <td style="text-align: center; width: 27%;">${element[2].toString()}</td>
                    <td style="text-align: center; width: 27%;">${element[3]}</td>
                  </tr>
                `
              if (element[5] && element[5] != '' && element[7] != 1) {
                html += `
                    <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
                  `
              }
            }
          } else {
            for (let i = 0; i < data.addprintDishList.length; i++) {
              const element = data.addprintDishList[i];
              html += `
                  <tr style="font-size: 12px; margin-bottom: 8px;">
                    <td style="text-align: left; width: 25%;">${i + 1}.${element[1]}</td>
                    <td style="text-align: center; width: 25%;">${element[4]}</td>
                    <td style="text-align: center; width: 25%;">${element[2].toString()}</td>
                    <td style="text-align: center; width: 25%;">${element[3]}</td>
                  </tr>
                `
              if (element[5] && element[5] != '' && element[7] != 1) {
                html += `
                    <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">【${element[5]}】</td></tr>
                  `
              }
            }
          }
          html += `
              </table>
            `
        }
      }
      html += `
          <div style="height: 1px; padding-top: 5px; border-top: 1px dashed black;"></div>
          <div style="font-size: 12px; margin-bottom: 4px;">订单合计：${data.allOriginalPrice}</div>
        `
      if (parseFloat(data.discount_price) > 0) {
        html += `
            <div style="font-size: 12px; margin-bottom: 4px;">[会员优惠:${data.member_level_rate >= 100 ? '' : parseFloat(data.member_level_rate / 10).toFixed(2) + '折'}]：-${data.discount_price}</div>
          `
      }
      if (parseFloat(data.dis_price) > 0 && data.discount_rate && data.discount_rate < 100) {
        html += `
            <div style="font-size: 12px; margin-bottom: 4px;">[整单打折:${data.discount_rate >= 100 ? '' : parseFloat(data.discount_rate / 10).toFixed(2) + '折'}]：-${data.dis_price}</div>
          `
      }
      if (parseFloat(data.wipe_price) > 0) {
        html += `
            <div style="font-size: 12px; margin-bottom: 4px;">[抹零]：-${data.wipe_price}</div>
          `
      }

      html += `
          <div style="font-size: 12px; margin-bottom: 4px; padding-top: 5px; border-top: 1px dashed black;">应收：${data.payPrice}</div>
        `
      if (parseFloat(data.return_money) > 0) {
        html += `
            <div style="font-size: 12px; margin-bottom: 4px;">退款：-${data.return_money}</div>
          `
      }
      html += `
          <div style="font-size: 14px; margin-bottom: 4px; font-weight: bold;">实收${data.pay_mode_text ? '(' + data.pay_mode_text + ')' : ''}:${data.allFactPrice}</div>
        `
      html += `
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px; padding-top: 5px; border-top: 1px dashed black;">门店地址：${data.address}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">联系电话：${data.phone}</div>
      `;
      html += `<div style="font-size: 13px; padding: 5px 0; margin-bottom: 10px; border-top: 1px dashed black; font-weight: 600; text-align: center;">店掌宝祝您用餐愉快！</div>`
      html += `</div>`
      html += `</div>`
      return html;
    }

    // 换台通知单
    if (data.type == 24) {
      let html = ``;
      if (printWidth == 58) {
        html = `<div style="width: 48mm;">`
      } else {
        html = `<div style="width: 70mm;">`
      }
      html += `
        <div style="padding: 5mm 0mm 8mm 0mm;">
          <div style="font-size: 20px; font-weight: bold; text-align: center; margin-bottom: 10px;">${data.shopName}</div>
          <div style="font-size: 18px; font-weight: bold; text-align: center; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px dashed black;">☆换台通知单☆</div>
      ` 
      html += `<div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 4px;">原桌位：${data.cur_desk_num}</div>`
      html += `<div style="font-size: 18px; font-weight: bold; text-align: left; margin-bottom: 10px;">更换到：${data.change_desk_num}</div>`
      html += `</div>`
      html += `</div>`
      return html;
    }

    // 标签制作单 60mm*40mm
    const labelSize = data.labelSize || 50;
    if (data.type == 25 && labelSize == 60) {
      let html = ``;
      html = `<div style="width: 57mm; height: 40mm; overflow: hidden;">`
      html += `<div style="padding: 1mm 0mm 0mm 1mm; overflow: hidden;">`
      let pack_or_dineIn_text = ``;
      if (data.pack_or_dineIn == 1) { // 打包
        pack_or_dineIn_text = '(打包)'
      } else if (data.pack_or_dineIn == 2) { // 堂食
        pack_or_dineIn_text = '(堂食)'
      }
      let number_text = '';
      if (data.meal_type == 1) {
        number_text = `${data.order_type}:${data.desk_num || data.num}`;
      } else if (data.meal_type == 2) {
        if (data.order_type_index == 1 || data.order_type_index == 2) {
          number_text = `${data.order_type}:${data.serial_number}${pack_or_dineIn_text}`;
        } else {
          number_text = `${data.order_type}:${data.pick_order_num}${pack_or_dineIn_text}`;
        }
      }
      html += `<div style="font-size: 16px; font-weight: 800; text-align: left; margin-bottom: 5px;">${number_text}</div>`
      html += `
          <div style="font-size: 16px; font-weight: 800; text-align: left; margin-bottom: 5px;">${data.food.food_name}<span style="margin-left: 5px; font-weight: 400;">${data.food.price}元</span></div>
        `
      // console.log(data.food.spec_attr_name.length);
      if (data.food.spec_attr_name && data.food.spec_attr_name != '' && data.food.food_spec_fake != 1) {
        if (data.food.spec_attr_name.length <= 28) {
          html += `<div style="font-size: 14px; font-weight: 800; text-align: left; margin-bottom: 5px;"
                  >【${data.food.spec_attr_name}】</div>`
        } else {
          html += `<div style="font-size: 13px; font-weight: 800; text-align: left; margin-bottom: 5px;"
                  >【${data.food.spec_attr_name.length > 37 ? data.food.spec_attr_name.substring(0, 35) + '...' : data.food.spec_attr_name}】</div>`
        }
      }

      let show_phone = '';
      if (data.order_type_index == 4 && data.c_phone && data.c_phone != '') {
        show_phone = data.c_phone;
      }
      if (data.order_type_index != 4 && data.member_phone && data.member_phone != '') {
        show_phone = data.member_phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
      }
      html += `<div style="font-size: 12px; text-align: left; margin-bottom: 3px;">${show_phone == '' ? '' : '电话:' + show_phone}</div>`

      html += `<div style="font-size: 12px; text-align: left; margin-bottom: 3px;">时间:${data.create_time}</div>`
      html += `<div style="font-size: 12px; text-align: left; margin-bottom: 3px;">${data.shopName}</div>`
      html += `</div>`
      html += `</div>`
      return html;
    }

    if (data.type == 25 && labelSize == 50) {
      let html = ``;
      html = `<div style="width: 46.3mm; height: 40mm; overflow: hidden;">`
      html += `<div style="padding: 1mm 0mm 0mm 0.1mm; overflow: hidden;">`
      let pack_or_dineIn_text = ``;
      if (data.pack_or_dineIn == 1) { // 打包
        pack_or_dineIn_text = '(打包)'
      } else if (data.pack_or_dineIn == 2) { // 堂食
        pack_or_dineIn_text = '(堂食)'
      }
      let number_text = '';
      if (data.meal_type == 1) {
        number_text = `${data.order_type}:${data.desk_num || data.num}`;
      } else if (data.meal_type == 2) {
        if (data.order_type_index == 1 || data.order_type_index == 2) {
          number_text = `${data.order_type}:${data.serial_number}${pack_or_dineIn_text}`;
        } else {
          number_text = `${data.order_type}:${data.pick_order_num}${pack_or_dineIn_text}`;
        }
      }
      html += `<div style="font-size: 14px; font-weight: 800; text-align: left; margin-bottom: 5px;">${number_text}</div>`
      html += `
          <div style="font-size: 14px; font-weight: 800; text-align: left; margin-bottom: 5px;">${data.food.food_name}<span style="margin-left: 5px; font-weight: 400;">${data.food.price}元</span></div>
        `
      // console.log(data.food.spec_attr_name.length);
      if (data.food.spec_attr_name && data.food.spec_attr_name != '' && data.food.food_spec_fake != 1) {
        if (data.food.spec_attr_name.length <= 15) {
          html += `<div style="font-size: 13px; font-weight: 800; text-align: left; margin-bottom: 5px;"
                  >【${data.food.spec_attr_name}】</div>`
        } else {
          html += `<div style="font-size: 12px; font-weight: 800; text-align: left; margin-bottom: 5px;"
                  >【${data.food.spec_attr_name.length > 33 ? data.food.spec_attr_name.substring(0, 30) + '...' : data.food.spec_attr_name}】</div>`
        }
      }

      let show_phone = '';
      if (data.order_type_index == 4 && data.c_phone && data.c_phone != '') {
        show_phone = data.c_phone;
      }
      if (data.order_type_index != 4 && data.member_phone && data.member_phone != '') {
        show_phone = data.member_phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
      }
      html += `<div style="font-size: 11px; text-align: left; margin-bottom: 3px;">${show_phone == '' ? '' : '电话:' + show_phone}</div>`

      html += `<div style="font-size: 11px; text-align: left; margin-bottom: 3px;">时间:${data.create_time}</div>`
      html += `<div style="font-size: 11px; text-align: left; margin-bottom: 3px;">${data.shopName}</div>`
      html += `</div>`
      html += `</div>`
      return html;
    }

    if (data.type == 25 && labelSize != 60 && labelSize != 50) {
      let html = ``;
      html = `<div style="width: 37mm; height: 30mm; overflow: hidden;">`
      html += `<div style="padding: 1mm 0mm 0mm 0.1mm; overflow: hidden;">`
      let pack_or_dineIn_text = ``;
      if (data.pack_or_dineIn == 1) { // 打包
        pack_or_dineIn_text = '(打包)'
      } else if (data.pack_or_dineIn == 2) { // 堂食
        pack_or_dineIn_text = '(堂食)'
      }
      let number_text = '';
      if (data.meal_type == 1) {
        number_text = `${data.order_type}:${data.desk_num || data.num}`;
      } else if (data.meal_type == 2) {
        if (data.order_type_index == 1 || data.order_type_index == 2) {
          number_text = `${data.order_type}:${data.serial_number}${pack_or_dineIn_text}`;
        } else {
          number_text = `${data.order_type}:${data.pick_order_num}${pack_or_dineIn_text}`;
        }
      }
      html += `<div style="font-size: 13px; font-weight: 800; text-align: left; margin-bottom: 3px;">${number_text}</div>`
      html += `
          <div style="font-size: 13px; font-weight: 800; text-align: left; margin-bottom: 3px;">${data.food.food_name}<span style="margin-left: 5px; font-weight: 400;">${data.food.price}元</span></div>
        `
      // console.log(data.food.spec_attr_name.length);
      if (data.food.spec_attr_name && data.food.spec_attr_name != '' && data.food.food_spec_fake != 1) {
        html += `<div style="font-size: 11px; font-weight: 800; text-align: left; margin-bottom: 3px;"
            >【${data.food.spec_attr_name.length > 27 ? data.food.spec_attr_name.substring(0, 26) + '...' : data.food.spec_attr_name}】</div>
          `
      }

      let show_phone = '';
      if (data.order_type_index == 4 && data.c_phone && data.c_phone != '') {
        show_phone = data.c_phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
      }
      if (data.order_type_index != 4 && data.member_phone && data.member_phone != '') {
        show_phone = data.member_phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
      }
      html += `<div style="font-size: 11px; text-align: left; margin-bottom: 3px;">${show_phone == '' ? '' : '电话:' + show_phone}</div>`

      html += `<div style="font-size: 11px; text-align: left; margin-bottom: 2px;">时间:${data.create_time}</div>`
      html += `<div style="font-size: 11px; text-align: left; margin-bottom: 3px;">${data.shopName}</div>`
      html += `</div>`
      html += `</div>`
      return html;
    }

    // 充值单
    if (data.type == 26) {
      let html = ``;
      if (printWidth == 58) {
        html = `<div style="width: 48mm;">`
      } else {
        html = `<div style="width: 70mm;">`
      }
      html += `
          <div style="padding: 5mm 0mm 8mm 0mm;">
            <div style="font-size: 20px; text-align: center; margin-bottom: 10px;">${data.shopName}</div>
        ` 
      html += `
          <div style="font-size: 18px; font-weight: bold; text-align: center; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px dashed black;">☆☆充值单☆☆</div>  
        `
      
      html += `
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">收银人员：${data.shop_admin_name}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">收银时间：${data.recharge_time}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">充值单号：${data.recharge_no}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">会员姓名：${data.member_name}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 5px; padding-bottom: 5px; border-bottom: 1px dashed black;">会员电话：${data.member_phone}</div>
        `

      html += `
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">充值金额：${data.amount}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">赠送金额：${data.give_amount}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">充值前余额：${data.recharge_before}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px; padding-bottom: 5px; border-bottom: 1px dashed black;">充值后余额：${data.recharge_after}</div>
        `

      html += `
          <div style="font-size: 14px; margin-bottom: 4px; font-weight: bold;">实收${data.pay_type_text ? '(' + data.pay_type_text + ')' : ''}:${data.amount}</div>
        `
      
      html += `
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px; padding-top: 5px; border-top: 1px dashed black;">门店地址：${data.shop_address}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">联系电话：${data.shop_phone}</div>
      `;
      html += `<div style="font-size: 13px; padding: 5px 0; margin-bottom: 10px; border-top: 1px dashed black; font-weight: 600; text-align: center;">店掌宝祝您用餐愉快！</div>`
      html += `</div>`
      html += `</div>`
      return html;
    }

    // 寄存单
    if (data.type == 28) {
      let html = ``;
      if (printWidth == 58) {
        html = `<div style="width: 48mm;">`
      } else {
        html = `<div style="width: 70mm;">`
      }
      html += `
          <div style="padding: 5mm 0mm 8mm 0mm;">
            <div style="font-size: 20px; text-align: center; margin-bottom: 10px;">${data.data.shopName}</div>
        ` 
      html += `
          <div style="font-size: 18px; font-weight: bold; text-align: center; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px dashed black;">☆☆寄存单☆☆</div>  
        `
      
      html += `
          <div style="font-size: 12px; font-weight: bold; text-align: left; margin-bottom: 4px;">寄存单号:${data.data.deposit_num}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">操作人员：${data.data.shop_admin_name}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 5px; padding-bottom: 5px; border-bottom: 1px dashed black;">寄存时间：${data.data.create_time}</div>
        `
      html += `
        <table style="font-size: 12px; margin-bottom: 10px; width: 100%;">
          <tr>
            <th style="text-align: left; width: 80%;">寄存物品</th>
            <th style="text-align: center; width: 19%;">数量</th>
          </tr>
        `
      for (let i = 0; i < data.data.good_list.length; i++) {
        const element = data.data.good_list[i];
        html += `
            <tr>
              <td style="text-align: left; width: 80%;">${i + 1}.${element.food_name}${element.spec && element.spec != '' ? '(' + element.spec + ')' : ''}</td>
              <td style="text-align: center; width: 19%;">${element.food_num}</td>
            </tr>
          `
        if (element.remark && element.remark != '') {
          html += `
              <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">[备注：${element.remark}]</td></tr>
            `
        }
      }
      html += `
          </table>
        `
      html += `
          <div style="font-size: 14px; margin-bottom: 4px; padding-top: 5px; border-top: 1px dashed black;">寄存人：${data.data.username}</div>
          <div style="font-size: 14px; margin-bottom: 4px;">手机号：${data.data.userphone}</div>
        `
      
      if (data.data.validity_time && data.data.validity_time != '') {
        html += `
            <div style="font-size: 12px; margin-bottom: 4px;">有效期：${data.data.validity_time}</div>
          `
      }
      html += `</div>`
      html += `</div>`
      return html;
    }

    // 取回单
    if (data.type == 29) {
      let html = ``;
      if (printWidth == 58) {
        html = `<div style="width: 48mm;">`
      } else {
        html = `<div style="width: 70mm;">`
      }
      html += `
          <div style="padding: 5mm 0mm 8mm 0mm;">
            <div style="font-size: 20px; text-align: center; margin-bottom: 10px;">${data.data.shopName}</div>
        ` 
      html += `
          <div style="font-size: 18px; font-weight: bold; text-align: center; margin-bottom: 10px; padding-bottom: 5px; border-bottom: 1px dashed black;">☆☆取回单☆☆</div>  
        `
      
      html += `
          <div style="font-size: 12px; font-weight: bold; text-align: left; margin-bottom: 4px;">寄存单号:${data.data.deposit_num}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 4px;">操作人员：${data.data.shop_admin_name}</div>
          <div style="font-size: 12px; text-align: left; margin-bottom: 5px; padding-bottom: 5px; border-bottom: 1px dashed black;">取回时间：${data.data.create_time}</div>
        `
      html += `
        <table style="font-size: 12px; margin-bottom: 10px; width: 100%;">
          <tr>
            <th style="text-align: left; width: 80%;">取回物品</th>
            <th style="text-align: center; width: 19%;">数量</th>
          </tr>
        `
      for (let i = 0; i < data.data.good_list.length; i++) {
        const element = data.data.good_list[i];
        html += `
            <tr>
              <td style="text-align: left; width: 80%;">${i + 1}.${element.food_name}${element.spec && element.spec != '' ? '(' + element.spec + ')' : ''}</td>
              <td style="text-align: center; width: 19%;">${element.take_num}</td>
            </tr>
          `
        if (element.remark && element.remark != '') {
          html += `
              <tr><td colspan="4" style="font-size: 12px; padding-left: 5px;">[备注：${element.remark}]</td></tr>
            `
        }
      }
      html += `
          </table>
        `
      if (data.data.remark && data.data.remark != '') {
        html += `
            <div style="font-size: 12px; margin-bottom: 4px; padding-top: 5px; border-top: 1px dashed black;">备注：${data.data.remark}</div>
          `
      }
      html += `
          <div style="font-size: 14px; margin-bottom: 4px; padding-top: 5px; border-top: 1px dashed black;">寄存人：${data.data.username}</div>
          <div style="font-size: 14px; margin-bottom: 4px;">手机号：${data.data.userphone}</div>
        `
      
      if (data.data.validity_time && data.data.validity_time != '') {
        html += `
            <div style="font-size: 12px; margin-bottom: 4px;">有效期：${data.data.validity_time}</div>
          `
      }
      html += `</div>`
      html += `</div>`
      return html;
    }

  }
}

export default lodopHelper;



// WEBPACK FOOTER //
// ./src/utils/lodopHtmlTemp.js